module.exports = __webpack_public_path__ + "static/media/smriti_2.4f96b53d.jpg";